// src/features/product-tours/scrollTourTargetIntoView.ts
// Fait apparaître la cible du guide même dans un conteneur scrollable (ex. sidebar).

function isScrollable(el: Element): boolean {
  if (!(el instanceof HTMLElement)) return false;
  const style = window.getComputedStyle(el);
  const overflowY = style.overflowY;
  const overflowX = style.overflowX;
  const canY =
    (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
    el.scrollHeight > el.clientHeight + 1;
  const canX =
    (overflowX === 'auto' || overflowX === 'scroll' || overflowX === 'overlay') &&
    el.scrollWidth > el.clientWidth + 1;
  return canY || canX;
}

function scrollParentToReveal(parent: HTMLElement, target: DOMRect): void {
  const parentRect = parent.getBoundingClientRect();
  const pad = 12;

  if (target.top < parentRect.top + pad) {
    parent.scrollTop -= parentRect.top + pad - target.top;
  } else if (target.bottom > parentRect.bottom - pad) {
    parent.scrollTop += target.bottom - (parentRect.bottom - pad);
  }

  if (target.left < parentRect.left + pad) {
    parent.scrollLeft -= parentRect.left + pad - target.left;
  } else if (target.right > parentRect.right - pad) {
    parent.scrollLeft += target.right - (parentRect.right - pad);
  }
}

/** Ouvre les sous-menus Ant Design fermés qui contiennent la cible. */
function expandAntSubmenus(el: Element): void {
  let node: Element | null = el;
  const opened: HTMLElement[] = [];
  while (node && node !== document.body) {
    if (
      node.classList.contains('ant-menu-submenu') &&
      !node.classList.contains('ant-menu-submenu-open')
    ) {
      const title = node.querySelector('.ant-menu-submenu-title') as HTMLElement | null;
      if (title) {
        title.click();
        opened.push(title);
      }
    }
    node = node.parentElement;
  }
  void opened;
}

/**
 * Scroll window + ancêtres overflow pour rendre `el` visible.
 * À appeler au highlight d’une étape de guide.
 */
export function scrollTourTargetIntoView(
  el: Element | null | undefined,
  options?: { block?: ScrollLogicalPosition }
): void {
  if (!el || !(el instanceof Element)) return;

  const block = options?.block ?? 'center';

  expandAntSubmenus(el);

  const run = () => {
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
      if (isScrollable(parent)) {
        scrollParentToReveal(parent, el.getBoundingClientRect());
      }
      parent = parent.parentElement;
    }

    const rect = el.getBoundingClientRect();
    const fullyVisible =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= window.innerHeight &&
      rect.right <= window.innerWidth;

    if (!fullyVisible || block === 'start') {
      el.scrollIntoView({
        behavior: 'smooth',
        block,
        inline: 'nearest',
      });
    }
  };

  run();
  window.setTimeout(run, 280);
}

